import { init } from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { buildMode, buildVersion } from "../../../common/environment";

export const initSentry = () => {
    let dsn = null
    let release = "";
    if (buildMode === 'production') {
        dsn = "https://aba9819933e4451c95c16ac82d30cede@o323461.ingest.sentry.io/5519969";
        release = `kd-store-web-pro@${buildVersion}`
    } else if (buildMode === 'staging') {
        dsn = "https://0b04e9c158a2465096f03cc5afd3b42c@o323461.ingest.sentry.io/5520011";
        release = `kd-store-web-staging@${buildVersion}`
    }

    if (dsn) {
        init({
            dsn: dsn,
            release: release,
            integrations: [
                new Integrations.BrowserTracing(),
            ],
            tracesSampleRate: 1.0,
        });
    }
}
